import React from "react";
import Meta from "../Meta";
import PageHeader from "../components/PageHeader";
import Loader from "../loader";
import ServicesRender from "../../Ummah/Services/services";
import { t } from "@lingui/core/macro";

const styles = `
.t26-services-page {
  padding: 0 clamp(16px, 4vw, 32px) clamp(40px, 6vw, 80px);
  max-width: var(--container);
  margin-inline: auto;
}
`;

export default function Services({ context, loading }) {
    const { org } = context;
    if (loading) {
        return (
            <>
                <Meta context={context} title={t`Services de ${org.name}`} />
                <Loader />
            </>
        );
    }
    return (
        <>
            <Meta context={context} title={t`Services de ${org.name}`} description={t`Tous les services proposés par ${org.name}`} />
            <style dangerouslySetInnerHTML={{ __html: styles }} />

            <PageHeader
                title={t`Activités`}
                subtitle={t`Tous nos services et activités`}
                crumbs={[
                    { label: t`Accueil`, url: org.BASE_WEB_URL },
                    { label: t`Activités` },
                ]}
            />

            <div className="t26-services-page">
                <ServicesRender context={context} />
            </div>
        </>
    );
}
